import './vendor';
import './helpers';
import './components';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import menu from './components/menu';
import lazyLoading from './modules/lazyLoading';
import scroller from './components/scroller';
import vars from './helpers';
import header from './components/header';
import scrollToAnchor from './modules/scrollToAnchor';
import footer from './components/footer';
import global from './globals';

ieFix();
vhFix();
actualYear();
scrollToAnchor.init();
vars.isScreen.isMobile(header.init, header.destroy);

menu.init();
vars.isScreen.isMobile(menu.initScrollbar, menu.destroyScrollbar);

if (global.scroller) {
	scroller.init();
}
vars.isScreen.isMobile(scroller.destroy, scroller.init);

vars.isScreen.isMobile(footer.init, footer.destroy);

lazyLoading.init();
